import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'infrastructure/redux/store';

const selectNavigationHistoryState = (state: RootState) => state.navigationHistory;

export const selectHistory = createSelector(
  [selectNavigationHistoryState],
  (navigationHistory) => navigationHistory.history,
);
